export default {
    MEDIA_RECEIVED: 'MEDIA_RECEIVED',
    MEDIA_REMOVED: 'MEDIA_REMOVED',

    UPLOAD_STARTED: 'UPLOAD_STARTED',
    UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',
    UPLOAD_COMPLETE: 'UPLOAD_COMPLETE',
    UPLOAD_ERROR: 'UPLOAD_ERROR',
};
